import { Button, DialogBox, DialogBoxActions } from "@/_component/Common";
import AssignContactDetails from "@/_component/shared/common/assignee/AssigneeContactDetails";
import { useLanguageContext } from "@/hooks";   
import { useEffect, useState } from "react";

export default function UpdatePostingDataPopup({ onClose, postingDetails, showAssignee, onUpdate }) {

    const { language } = useLanguageContext();

    const [postingUpdatedData, setPostingUpdatedData] = useState({
        id: "",
        assigneeUserId: "",
        assigneeUserName: "",
        price: ""
    });

    const handleAutoFillEditFormData = () => {
        if (!postingDetails) return;
        setPostingUpdatedData({
            id: postingDetails.id,
            assigneeUserId: postingDetails.assigneeUserId,
            assigneeUserName: postingDetails.assigneeUserName,
            price: postingDetails.price
        });
    }

    const handleAssigneeFormData = (assigneeData) => {
        setPostingUpdatedData((prevState) => {
            const updatedState = {
                ...prevState,
                ...assigneeData
            };
            return updatedState;
        });
    }

    const handleChangeInput = (e) => {
        const { name, value } = e.target;
        setPostingUpdatedData(prevState => {
            const updatedState = { ...prevState, [name]: value }
            return updatedState;
        });
    }

    const handleUpdatePostingData = (e) => {
        e.preventDefault();
        onUpdate(postingUpdatedData);
    }

    useEffect(() => {
        handleAutoFillEditFormData();
    }, []);

    return (
        <DialogBox title={"Update Posting Details"} width="30rem" onClose={onClose}>
            <form onSubmit={handleUpdatePostingData}>
                <div className="d-flex flex-column gap-2">
                    <div>
                        <label htmlFor="price" className="form-label">{language("label.price")}</label>
                        <input type="number" name="price" id="price" className="form-control" value={postingUpdatedData.price} onChange={handleChangeInput} />
                    </div>
                    {showAssignee && <div>
                        <AssignContactDetails assigneData={{ assigneeUserName: postingUpdatedData.assigneeUserName, assigneeUserId: postingUpdatedData.assigneeUserId }} saveAssigne={handleAssigneeFormData} />
                    </div>}
                </div>
                <DialogBoxActions>
                    <Button primary solid rounded type="submit"><span>{language("label.update_now")}</span></Button>
                </DialogBoxActions>
            </form>
        </DialogBox>
    )
}